import React__default, { useReducer, useMemo, createContext, useContext } from 'react';

// TODO: Simplify a11y markup
// https://github.com/Shopify/online-store-ui/issues/3648
const DEFAULT_CONTEXT = {
  dispatch: () => {},
  buttons: new Map(),
  titles: new Map(),
  visuallyHiddenTitles: new Map(),
  noVisibleHeaderContent: true
};
let CompoundComponentValue = /*#__PURE__*/function (CompoundComponentValue) {
  CompoundComponentValue["Button"] = "Button";
  CompoundComponentValue["Title"] = "Title";
  CompoundComponentValue["VisuallyHiddenTitle"] = "VisuallyHiddenTitle";
  return CompoundComponentValue;
}({});
let Action = /*#__PURE__*/function (Action) {
  Action["RegisterButton"] = "RegisterButton";
  Action["UpdateButton"] = "UpdateButton";
  Action["UnregisterButton"] = "UnregisterButton";
  Action["RegisterTitle"] = "RegisterTitle";
  Action["UpdateTitle"] = "UpdateTitle";
  Action["UnregisterTitle"] = "UnregisterTitle";
  Action["RegisterVisuallyHiddenTitle"] = "RegisterVisuallyHiddenTitle";
  Action["UpdateVisuallyHiddenTitle"] = "UpdateVisuallyHiddenTitle";
  Action["UnregisterVisuallyHiddenTitle"] = "UnregisterVisuallyHiddenTitle";
  return Action;
}({});
const CompoundComponentContext = /*#__PURE__*/createContext(DEFAULT_CONTEXT);
function getInitialState() {
  return DEFAULT_CONTEXT;
}
function reducer(state, action) {
  switch (action.type) {
    case Action.RegisterButton:
      {
        const newButtons = new Map(state.buttons.entries());
        newButtons.set(action.payload.id, action.payload);
        return {
          ...state,
          buttons: newButtons
        };
      }
    case Action.UpdateButton:
      {
        const newButtons = new Map(state.buttons.entries());
        newButtons.set(action.payload.id, action.payload);
        if (!action.payload.id) {
          return {
            ...state
          };
        }
        return {
          ...state,
          buttons: newButtons
        };
      }
    case Action.UnregisterButton:
      {
        const newButtons = new Map(state.buttons.entries());
        newButtons.delete(action.payload.id);
        return {
          ...state,
          buttons: newButtons
        };
      }
    case Action.RegisterTitle:
      {
        const newTitles = new Map(state.titles.entries());
        newTitles.set(action.payload.id, action.payload);
        return {
          ...state,
          titles: newTitles
        };
      }
    case Action.UpdateTitle:
      {
        const newTitles = new Map(state.titles.entries());
        newTitles.set(action.payload.id, action.payload);
        if (!action.payload.id) {
          return {
            ...state
          };
        }
        return {
          ...state,
          titles: newTitles
        };
      }
    case Action.UnregisterTitle:
      {
        const newTitles = new Map(state.titles.entries());
        newTitles.delete(action.payload.id);
        return {
          ...state,
          titles: newTitles
        };
      }
    case Action.RegisterVisuallyHiddenTitle:
      {
        const newVisuallyHiddenTitles = new Map(state.visuallyHiddenTitles.entries());
        newVisuallyHiddenTitles.set(action.payload.id, action.payload);
        return {
          ...state,
          visuallyHiddenTitles: newVisuallyHiddenTitles
        };
      }
    case Action.UpdateVisuallyHiddenTitle:
      {
        const newVisuallyHiddenTitles = new Map(state.visuallyHiddenTitles.entries());
        newVisuallyHiddenTitles.set(action.payload.id, action.payload);
        if (!action.payload.id) {
          return {
            ...state
          };
        }
        return {
          ...state,
          visuallyHiddenTitles: newVisuallyHiddenTitles
        };
      }
    case Action.UnregisterVisuallyHiddenTitle:
      {
        const newVisuallyHiddenTitles = new Map(state.visuallyHiddenTitles.entries());
        newVisuallyHiddenTitles.delete(action.payload.id);
        return {
          ...state,
          visuallyHiddenTitles: newVisuallyHiddenTitles
        };
      }
    default:
      return {
        ...state
      };
  }
}
function CompoundComponentProvider({
  children
}) {
  const [state, dispatch] = useReducer(reducer, undefined, getInitialState);
  const context = useMemo(() => ({
    dispatch,
    buttons: state.buttons,
    titles: state.titles,
    visuallyHiddenTitles: state.visuallyHiddenTitles,
    noVisibleHeaderContent: state.buttons.size === 0 && state.titles.size === 0
  }), [state]);
  return /*#__PURE__*/React__default.createElement(CompoundComponentContext.Provider, {
    value: context
  }, children);
}
function useCompoundComponentProviderContext() {
  return useContext(CompoundComponentContext);
}

export { Action, CompoundComponentContext, CompoundComponentProvider, CompoundComponentValue, useCompoundComponentProviderContext };
